const WHEEL_LISTENER_OPTIONS = { passive: false }

function isNumberInput(target) {
  return target instanceof HTMLInputElement && target.type === 'number'
}

export default {
  bind(el) {
    const handler = event => {
      if (!isNumberInput(event.target)) {
        return
      }

      event.preventDefault()
    }

    el.__vueDisableNumberScroll__ = handler
    el.addEventListener('wheel', handler, WHEEL_LISTENER_OPTIONS)
  },

  unbind(el) {
    el.removeEventListener(
      'wheel',
      el.__vueDisableNumberScroll__,
      WHEEL_LISTENER_OPTIONS
    )
    el.__vueDisableNumberScroll__ = null
  },
}
